import { logger } from 'module/logger';
import { Editor } from '@tiptap/core';
import { PagesAPI } from 'api/pages';
import {
  exportDocxAndDownload,
  exportPdfAndDownload,
  prefetchImagesForExport,
} from 'components/organisms/document-editor/extensions/export-pdf/export-pdf-config';

export type DocumentExportFormat = 'pdf' | 'docx';

export type RunDocumentExportParams = {
  format: DocumentExportFormat;
  editor: Editor;
  imageUrls: string[];
  documentTitle?: string;
};

export async function runDocumentExport({
  format,
  editor,
  imageUrls,
  documentTitle,
}: RunDocumentExportParams): Promise<void> {
  try {
    await prefetchImagesForExport(imageUrls, editor);
  } catch (error) {
    logger.error('Image prefetch failed', { error });
  }

  if (format === 'pdf') {
    const { convertToken } = await PagesAPI.getConvertToken();

    await exportPdfAndDownload(editor, {
      token: convertToken,
      filename: `${documentTitle || 'document'}.pdf`,
    });

    return;
  }

  await exportDocxAndDownload(editor, {
    filename: `${documentTitle || 'document'}.docx`,
  });
}
